export enum ColumnType {
    Action = 'action',
    Address = 'address',
    Checkbox = 'checkbox',
    Currency = 'currency',
    CurrencyMinZero = 'currencyMinZero',
    CurrencyNullZero = 'currencyNullZero',
    Date = 'date',
    DateTime = 'dateTime',
    Days = 'days',
    Enum = 'enum',
    FileNames = 'fileNames',
    Guid = 'guid',
    Hidden = 'hidden',
    Json = 'json',
    Number = 'number',
    Percent = 'percent',
    PercentWhole = 'percentWhole',
    PercentFromDecimal = 'percentFromDecimal',
    PercentFromDecimalWhole = 'percentFromDecimalWhole',
    RowCounter = 'row-counter',
    Spacer = 'spacer',
    Text = 'text',
    TextArray = 'textArray'
}
